"use client";
import UseSticky from "@/hooks/UseSticky";
import { usePathname } from "next/navigation";
import { useState, useEffect } from "react";

const ScrollToTop = () => {
  const { sticky }: { sticky: boolean } = UseSticky(400);

  const [showScroll, setShowScroll] = useState(false);

  const pathname = usePathname();

  const checkScrollTop = () => {
    if (!showScroll && window.pageYOffset > 400) {
      setShowScroll(true);
    } else if (showScroll && window.pageYOffset <= 400) {
      setShowScroll(false);
    }
  };

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    const checkScrollTop = () => {
      if (!showScroll && window.pageYOffset > 400) {
        setShowScroll(true);
      } else if (showScroll && window.pageYOffset <= 400) {
        setShowScroll(false);
      }
    };

    window.addEventListener("scroll", checkScrollTop);
    return () => window.removeEventListener("scroll", checkScrollTop);
  }, [checkScrollTop]);

  const isHome = pathname === "/";

  const getPosition = () => {
    if (typeof window === "undefined") return;

    const isSmall = window.innerWidth < 992;

    if (!showScroll) {
      return;
    }

    if (isHome) {
      return "80px";
    }

    return isSmall ? "130px" : "80px";
  };

  return (
    <>
      <button
        onClick={scrollTop}
        className={`scroll-top scroll-to-target ${sticky ? "open" : ""}`}
        style={{
          bottom: getPosition(),
        }}
      >
        <i className="fas fa-angle-up"></i>
      </button>
    </>
  );
};

export default ScrollToTop;
